export const AREA_CODES = ["SE1", "SE2", "SE3", "SE4"];

// Multi-country preview (REACT_APP_MULTIZONE=true): Norway, Finland and Denmark
// alongside Sweden, each with the standard forecast (and Pro for Premium).
export const MULTIZONE_ENABLED = process.env.REACT_APP_MULTIZONE === "true";

export const COUNTRY_AREAS: Record<string, string[]> = {
  SE: AREA_CODES,
  NO: ["NO1", "NO2", "NO3", "NO4", "NO5"],
  FI: ["FI"],
  DK: ["DK1", "DK2"],
};

export const COUNTRIES = MULTIZONE_ENABLED ? Object.keys(COUNTRY_AREAS) : ["SE"];
export const ALL_AREA_CODES = COUNTRIES.flatMap((c) => COUNTRY_AREAS[c]);

export const countryOf = (area: string): string =>
  Object.keys(COUNTRY_AREAS).find((c) => COUNTRY_AREAS[c].includes(area)) ?? "SE";

// Zones shown together (picker, price list): the selected area's country.
export const areasInCountry = (area: string): string[] => COUNTRY_AREAS[countryOf(area)];

// One colour per zone, unique across countries (picker, charts, map borders).
// rgba strings: the charts derive fills and highlights by parsing them.
const AREA_COLOR_LIGHT: Record<string, string> = {
  SE1: "rgba(83, 108, 146, 1)",
  SE2: "rgba(146, 83, 108, 1)",
  SE3: "rgba(108, 146, 83, 1)",
  SE4: "rgba(83, 146, 108, 1)",
  NO1: "rgba(176, 112, 58, 1)",
  NO2: "rgba(122, 90, 166, 1)",
  NO3: "rgba(58, 143, 176, 1)",
  NO4: "rgba(168, 150, 58, 1)",
  NO5: "rgba(176, 74, 66, 1)",
  FI: "rgba(58, 79, 176, 1)",
  DK1: "rgba(176, 74, 146, 1)",
  DK2: "rgba(42, 160, 160, 1)",
};

// Brighter variants for dark mode (increased brightness, slightly desaturated)
const AREA_COLOR_DARK: Record<string, string> = {
  SE1: "rgba(130, 160, 200, 1)",
  SE2: "rgba(200, 130, 160, 1)",
  SE3: "rgba(160, 200, 130, 1)",
  SE4: "rgba(130, 200, 160, 1)",
  NO1: "rgba(215, 160, 110, 1)",
  NO2: "rgba(170, 145, 210, 1)",
  NO3: "rgba(110, 185, 215, 1)",
  NO4: "rgba(210, 195, 110, 1)",
  NO5: "rgba(215, 125, 118, 1)",
  FI: "rgba(120, 140, 220, 1)",
  DK1: "rgba(215, 125, 190, 1)",
  DK2: "rgba(100, 205, 205, 1)",
};

export const areaColor = (area: string, dark = false): string =>
  (dark ? AREA_COLOR_DARK : AREA_COLOR_LIGHT)[area] ?? (dark ? AREA_COLOR_DARK.SE1 : AREA_COLOR_LIGHT.SE1);

export const AREA_PREDICTION_COLORS = [
  "rgba(255, 99, 132, 1)", // Bright red
  "rgba(54, 162, 235, 1)", // Bright blue
  "rgba(255, 205, 86, 1)", // Bright yellow
  "rgba(75, 192, 192, 1)", // Bright teal
];
